import React from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";
import { SERVICES_DETAILS01 } from "../../lib/assets";
import { SERVICES } from "../../content/siteContent";
import { ContactNumbers } from "../ContactNumbers/ContactNumbers";

export const ServicesDetailsSidebar = ({
  hideContact = false,
  hideTitle = false,
}) => {
  const { pathname } = useLocation();
  const services = SERVICES.map((item) => ({
    label: item.navTitle,
    href: `/services/${item.slug}`,
  }));

  const listMarkup = (
    <div className="services-cat-list">
      <ul className="list-wrap">
        {services.map((item) => (
          <li key={item.label} className={cn({ active: pathname === item.href })}>
            <Link to={item.href}>
              {item.label} <i className="flaticon-right-arrow"></i>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <aside className="services-sidebar">
      {hideTitle ? (
        <div className="services-cat-list mb-30">{listMarkup.props.children}</div>
      ) : (
        <div className="services-widget">
          <h4 className="sw-title">Our Services</h4>
          {listMarkup}
        </div>
      )}

      <div className="services-widget">
        <h4 className="sw-title">Brochure</h4>
        <div className="services-brochure-wrap">
          <p>Contact Zawix for business profiles, service notes, and consultation support.</p>
          <a
            href={SERVICES_DETAILS01}
            target="_blank"
            rel="noreferrer"
            download
            className="download-btn"
          >
            <i className="far fa-file-pdf"></i>Business Profile
          </a>
          <a
            href={SERVICES_DETAILS01}
            target="_blank"
            rel="noreferrer"
            download
            className="download-btn"
          >
            <i className="far fa-file-alt"></i>Service Notes
          </a>
        </div>
      </div>

      {hideContact ? null : (
        <div className="services-widget services-sidebar-contact">
          <h4 className="title">If You Need Any Help Contact With Us</h4>
          <ContactNumbers className="sidebar-contact-numbers" />
        </div>
      )}

      <div className="services-widget">
        <h4 className="sw-title">Get a Free Quote</h4>
        <div className="services-widget-form">
          <form action="#">
            <div className="form-grp">
              <input type="text" placeholder="Your Name" />
            </div>
            <div className="form-grp">
              <input type="email" placeholder="E-mail Address" />
            </div>
            <div className="form-grp">
              <textarea
                name="message"
                placeholder="Message / How Can We Help?"
              ></textarea>
            </div>
            <button type="submit" className="submit-btn">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </aside>
  );
};
